const FETCH_RECENT_SAMPLES = "recent_samples/FETCH_RECENT_SAMPLES";
const FETCH_RECENT_SAMPLES_SUCCESS = "recent_samples/FETCH_RECENT_SAMPLES_SUCCESS";
const FETCH_RECENT_SAMPLES_FAIL = "recent_samples/FETCH_RECENT_SAMPLES_FAIL"; 

const initialState = {
  pending: true,
  loaded: false,
  images: null,
  errors: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_RECENT_SAMPLES:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_RECENT_SAMPLES_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        images: { ...action.results },
        errors: null
      });
    case FETCH_RECENT_SAMPLES_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        errors: action.errors
      });

    default:
      return state;
  }
}

export function fetchRecentSamplesPending() {
  return {
    type: FETCH_RECENT_SAMPLES
  };
}

export function fetchRecentSamplesSuccess(results) {
  return {
    type: FETCH_RECENT_SAMPLES_SUCCESS,
    results
  };
}

export function fetchRecentSamplesFail(errors) {
  return {
    type: FETCH_RECENT_SAMPLES_FAIL,
    errors
  };
}

export const getRecentSamples = state => state.recent_samples;
